/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import BaseUrls from '../../utils/baseUrls';
import { prefixPath } from '../../utils/helpers';
import ApiRequests from '../../utils/RequestBody';
import Urls from '../../utils/urls';
import apiBackendInstance from '../../utils/axios';

interface props{
    id:string
}
export function updateStateForCrossWindowChanges() {
  const localVal = localStorage.getItem('updateState');
  if (localVal && localVal === 'yes') { localStorage.setItem('updateState', 'no'); } else {
    localStorage.setItem('updateState', 'yes');
  }
}
const DigitalOceanBody = ({ id }:props) => {
  const queryParams = new URLSearchParams(window.location.search);
  const status = queryParams.get('status');
  if (status && (status === 'success' || status === 'fail')) {
    setTimeout(() => {
      updateStateForCrossWindowChanges();
      window.close();
    }, 3000);
  }
  const [name, setName] = useState('');
  const [credlabel, setCredLabel] = useState('');
  const [nameValidationMessage, setNameValidationMessage] = useState(false as boolean|string);
  const [credlabelValidationMessage, setCredLabelValidationMessage] = useState(false as boolean|string);
  const create = () => {
    const createBtn:any = document.getElementById('createBtn');
    const spinnerDiv = document.getElementById('spinnerDiv');
    if (createBtn) {
      createBtn.disabled = true;
    }
    if (spinnerDiv) {
      spinnerDiv.style.display = 'block';
    }
    apiBackendInstance.post(Urls.createCloudAuthorizationById(id),
      {
        data: ApiRequests
          .createCloudDigitaltBody(
            credlabel, name,
          ),
      }).then((response) => {
      const { data } = response;
      if (data.success) {
        updateStateForCrossWindowChanges();
        if (createBtn) {
          createBtn.disabled = false;
        }
        if (spinnerDiv) {
          spinnerDiv.style.display = 'none';
        }
        const div2 = document.getElementById('succ');
        if (div2) div2.style.display = 'block';
        const url = data.data.redirectURL;
        window.location = url;
        // setTimeout(() => { window.close(); }, 3000);
      }
    }).catch(() => {
      setTimeout(() => { window.close(); }, 3000);
      updateStateForCrossWindowChanges();
      if (createBtn) {
        createBtn.disabled = false;
      }
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      const div2 = document.getElementById('fail');
      if (div2) div2.style.display = 'block';
    });
  };
  const credNameRule = ():boolean => {
    if (name === '' || name.length > 64) {
      if (name === '' || name.length === 0) { setNameValidationMessage('invalid cred name: name is empty'); }
      if (name.length > 64) { setNameValidationMessage('invalid cred name: name length exceed 64'); }
      return false;
    }
    return true;
  };
  const credLabelRule = ():boolean => {
    if (credlabel === '' || credlabel.length > 64 || credlabel.indexOf(' ') >= 0) {
      if (credlabel === '') setCredLabelValidationMessage('invalid cred label: label is empty');
      if (credlabel.length > 64) setCredLabelValidationMessage('invalid cred label: label exceed 64 chars');
      if (credlabel.indexOf(' ') >= 0) setCredLabelValidationMessage('invalid cred label: cannot have space');
      return false;
    }
    return true;
  };
  const validate = ():boolean => {
    let flag = true;
    if (!credNameRule()) {
      flag = false;
    }
    if (!credLabelRule()) {
      flag = false;
    }
    return flag;
  };
  const baseUrl = window.location.origin;
  const theme = BaseUrls.getkey();
  const logo = baseUrl + prefixPath(`/img/${theme}/navLogo.png`);
  const infoImg = baseUrl + prefixPath(`/img/${theme}/info.svg`);
  return (
        <>
        <div id="status" />
            <main>
            {status === 'success' ? (
              <div id="succ" className="alert alert-success text-center" style={{ display: 'block' }} role="alert">cloud successfully authorized</div>
            ) : status === 'fail' ? (
            <div className="alert alert-danger text-center" id="fail" style={{ display: 'block' }} role="alert">There was an error authorizing the cloud account</div>
            ) : ''}
{ !status
                && (
                <div className="container d-flex justify-content-center mt-4 pt-5">
                    {/* right part starts here */}
                    <section className="col-xl-5 addCloudBody col-lg-5 col-md-7 col-sm-12 p-5">
                        <div className="col-xl-10 mx-auto">
                            <div className="text-center mt-5 mb-4">
                             <img src={logo} className="img-responsive" alt="logo" />
                            </div>
                            <h6 className="mb-5 text-center">Authorize your Digital Ocean account</h6>
                            <div className=" form-floating cordaversion addCloudField d-flex">
                                <input
                                    type="text"
                                    className={`form-control addCloudField col-11 ${nameValidationMessage ? 'is-invalid' : ''}`}
                                    placeholder="Name"
                                    name="Name"
                                    onChange={(e) => { setName(e.target.value); }}
                                    onFocus={() => { setNameValidationMessage(false); }}
                                />
                                <label htmlFor="floatingPassword" className="form-pswd">
                                    Name
                                </label>
                                <span title="Name to save key on platform">
                                      <img className="mt-3 mx-2" src={infoImg} alt="" />
                                </span>

                            </div>
                            {nameValidationMessage !== false && (
                              <div className="text text-danger text-center">
                                            {nameValidationMessage}
                              </div>
                            )}
                            <div className=" mt-3">
                                <div className=" form-floating cordaversion">
                                    <input
                                        type="text"
                                        className={`form-control addCloudField col-11 ${credlabelValidationMessage ? 'is-invalid' : ''}`}
                                        placeholder="Secretkey"
                                        onChange={(e) => { setCredLabel(e.target.value); }}
                                        onFocus={() => { setCredLabelValidationMessage(false); }}
                                    />
                                    <label htmlFor="floatingPassword" className="form-pswd">
                                        Credential Label
                                    </label>

                                </div>
                            </div>
                            {credlabelValidationMessage !== false && (
                                      <div className="text text-danger text-center">
                                            {credlabelValidationMessage}
                                      </div>
                            )}
                            <div className="mt-4 mb-5  col-xl-12 col-lg-12 col-md-12 text-center">
                                <button type="submit" id="createBtn" className="btn comingSoon" onClick={() => { if (validate()) create(); }}>
                                    Add Cloud
                                </button>
                            </div>
                        </div>
                    </section>
                    {/* right part ends here */}
                </div>
                )}
            </main>
        </>
  );
};
export default DigitalOceanBody;